<div class="go-toast" [ngClass]="{'go-toast--dark': theme === 'dark'}">
  <div class="go-toast-strip" [ngClass]="_status"></div>
  <div class="go-toast-status">
    <go-icon
      class="go-toast-status__icon"
      [ngClass]="_status"
      [icon]="_icon">
    </go-icon>
  </div>
  <div
    class="go-toast__container"
    [ngClass]="enableMaxHeight ? 'go-toast__container--max-height' : 'go-toast__container'">
    <div
      class="go-toast-content"
      [ngClass]="{ 'go-toast-content--no-title': !header }">
      <h4
        class="go-heading-4 go-toast-content__title"
        *ngIf="header || headerContent">
        <ng-container *ngIf="headerContent; else headerContentElse">
          <ng-container *ngTemplateOutlet="headerContent"></ng-container>
        </ng-container>
        <ng-template #headerContentElse>
          {{ header }}
        </ng-template>
      </h4>
  
      <ng-container *ngIf="messageContent; else messageContentElse">
        <p class="go-toast-content__message">
         <ng-container *ngTemplateOutlet="messageContent"></ng-container>
        </p>
      </ng-container>
      <ng-template #messageContentElse>
        <p
          class="go-toast-content__message"
          [innerHTML]="message">
        </p>
      </ng-template>
    </div>
    <div
      class="go-toast-dismiss"
      *ngIf="dismissable">
      <go-icon-button
        buttonIcon="close"
        (handleClick)="dismiss()">
      </go-icon-button>
    </div>
    <div class="go-toast__actions" *ngIf="showToastActions">
      <ng-content select="[go-toast-action]"></ng-content>
    </div>
  </div>
</div>
